import React, {Component} from 'react';
import GoogleMail from "./mail";
import MapContainer from "./map";

class Content extends Component {

    constructor(props, context) {
        super(props, context);

    }

    render() {
        return (
            <div className="template-content">


                <div className="template-content-section template-main">


                    <div
                        className="template-component-feature template-component-feature-style-1 template-component-feature-position-left template-component-feature-size-medium">


                        <ul className="template-layout-33x33x33 template-clear-fix">


                            <li className="template-layout-column-left">
                                <div className="template-icon-feature template-icon-feature-name-envelope-alt"></div>
                                <h5>Adres</h5>
                                <p>
                                    Ahmet Taner Kışlalı mah<br/>
                                    2742 sk. No:6<br/>
                                    ANKARA
                                </p>
                            </li>


                            <li className="template-layout-column-center">
                                <div className="template-icon-feature template-icon-feature-name-mobile-alt"></div>
                                <h5>Telefon & E-mail</h5>
                                <p>
                                    Tel  :  <a href="tel:0312-240-1500"  >0312 240 15 00</a><br/>
                                    Cep : <a href="tel:0552-453-0015"  >0552 453 00 15</a>
                                    <br/>
                                    <a href="mailto:iletisim@turuncumontessori.com" >iletisim@turuncumontessori.com</a>
                                </p>
                            </li>


                            <li className="template-layout-column-right template-margin-bottom-5">
                                <div className="template-icon-feature template-icon-feature-name-clock-alt"></div>
                                <h5>Çalışma Saatleri</h5>
                                <p>
                                    Pazartesi – Cuma<br/>
                                    08:00  – 19:00 <br/>
                                </p>
                            </li>

                        </ul>

                    </div>

                    {/*<GoogleMail></GoogleMail>*/}

                </div>

                <MapContainer></MapContainer>

            </div>
        );
    }
}

export default Content;
